export default "__VITE_ASSET__1fd6510d__"